import { useContext } from 'react';
import { cCurrencyCodeContext } from './context';

export const useCCurrencyCode = () => {
  const cCurrencyCode = useContext(cCurrencyCodeContext);
  return cCurrencyCode;
};
